var _polygon, _path, _polygon2, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#F57F17",
    points: "12.314 10.903 3.336 19.254 10.086 6.408 12.314 10.903"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    d: "M10.086,6.408l-6.75,12.846L6.344,0.477c0.113-0.582,0.443-0.641,0.741-0.126L10.086,6.408L10.086,6.408z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#D56F14",
    points: "6.711 12.831 3.336 19.254 6.711 16.115 6.711 12.831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE8B00",
    d: "M6.689,0H6.67C6.525,0.007,6.404,0.169,6.344,0.477L3.336,19.254l3.375-6.423V0.002C6.704,0.001,6.697,0,6.689,0L6.689,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    d: "M14.714,8.669l-2.4,2.235l-2.229-4.496l1.152-2.585c0.291-0.516,0.766-0.523,1.058,0L14.714,8.669L14.714,8.669z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE8B00",
    d: "M11.767,3.433c-0.192,0-0.385,0.131-0.531,0.389l-1.152,2.585L12,10.271V3.499C11.925,3.455,11.846,3.433,11.767,3.433L11.767,3.433z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCA28",
    d: "M17.346,5.251c0.43-0.41,0.873-0.272,0.984,0.311l2.334,13.58l-7.741,4.648C12.651,23.94,11.931,24,11.931,24s-0.654-0.08-0.905-0.218l-7.689-4.528L17.346,5.251L17.346,5.251z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEB023",
    d: "M17.832,5.015c-0.151,0-0.32,0.077-0.487,0.236L3.336,19.254l7.689,4.528C11.276,23.921,11.931,24,11.931,24s0.721-0.06,0.992-0.211l1.595-0.958L18.021,5.06C17.963,5.03,17.9,5.015,17.832,5.015L17.832,5.015z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.c5ed7d714c27503a0157059c6d000dc3.svg";
export { ForwardRef as ReactComponent };